export const Severities = {
    0: 'Major',
    1: 'Moderate',
    2: 'Minor'
}